import { brand } from "@/brandVariables/getBandVariables";
import React from "react";

export const RacingCountdown = ({ timeObj }) => {
  const isElgigantenAlt = brand.client === "elgiganten-9u2oj" ? "isElgiganten" : "";

  const formatTime = (unit) => {
    const str = timeObj?.[unit]?.replace(":", "") || "--";
    return str.padEnd(2, "-").slice(0, 2).split("");
  };

  return (
    <section>
      {["hours", "minutes", "seconds"].map((unit, i) => (
        <React.Fragment key={unit}>
          <div>
            {formatTime(unit).map((digit, idx) => (
              <p key={idx} className={isElgigantenAlt}>
                {digit}
              </p>
            ))}
          </div>
          {i < 2 && <span />}
        </React.Fragment>
      ))}
    </section>
  );
};
